<template>
    <div class="row">
        <div class="col-12 col-xl-8 offset-xl-2">
            <form @submit.prevent="save('invoices')">
                <div class="card">
                    <div class="card-body">
                        <div class="air__utils__heading">
                            <h5>Albaranes</h5>
                        </div>

                        <div class="row">
                            <div class="col-sm-6">
                                <a-form-item label="Nombre de la empresa" required>
                                    <a-input v-model="config.name" required>
                                        <fa-icon slot="prefix" :icon="['fas', 'home']" />
                                    </a-input>
                                </a-form-item>

                                <a-form-item label="CIF" required>
                                    <a-input v-model="config.CIF">
                                        <fa-icon slot="prefix" :icon="['fas', 'id-card']" />
                                    </a-input>
                                </a-form-item>
                            </div>

                            <div class="col-sm-6">
                                <a-form-item label="Email de la empresa">
                                    <a-input v-model="config.mail" type="email">
                                        <fa-icon slot="prefix" :icon="['fas', 'envelope']" />
                                    </a-input>
                                </a-form-item>

                                <a-form-item label="Teléfono" class="mb-0">
                                    <a-input v-model="config.phone">
                                        <fa-icon slot="prefix" :icon="['fas', 'phone']" />
                                    </a-input>
                                </a-form-item>
                            </div>
                        </div>

                        <div class="row mt-5 mt-sm-0">
                            <div class="col-12 col-sm-6">
                                <a-form-item label="Direccion" required>
                                    <a-input v-model="config.address">
                                        <fa-icon slot="prefix" :icon="['fas', 'map-marked-alt']" />
                                    </a-input>
                                </a-form-item>

                                <a-form-item label="Direccion 2">
                                    <a-input v-model="config.address2">
                                        <fa-icon slot="prefix" :icon="['fas', 'map-marked-alt']" />
                                    </a-input>
                                </a-form-item>
                            </div>

                            <div class="col-12 col-sm-6 align-self-end">
                                <a-upload
                                    name="logo"
                                    class="logoUpload"
                                    list-type="picture-card"
                                    :show-upload-list="false"
                                    :before-upload="beforeUpload"
                                    accept="image/x-png,image/gif,image/jpeg"
                                    @change="handleChange"
                                >
                                    <img v-if="imageUrl" :src="imageUrl" alt="avatar" />
                                    <div v-else>
                                        <a-icon :type="uploading ? 'loading' : 'plus'" />
                                        <div class="ant-upload-text">Subir</div>
                                    </div>
                                </a-upload>
                            </div>
                        </div>
                    </div>

                    <div class="card-footer d-flex">
                        <div>
                            <a-switch v-model="config.enableTaxes" class="mr-2" />
                            Activar impuestos
                        </div>

                        <a-button
                            class="ml-auto"
                            type="primary"
                            :loading="loading"
                            :disabled="!validated('invoices')"
                            @click="save('invoices')"
                        >
                            Guardar
                        </a-button>
                    </div>
                </div>
            </form>

            <div class="card">
                <div class="card-body">
                    <div class="air__utils__heading">
                        <h5>Tracking GPS</h5>
                    </div>

                    <div class="row">
                        <div class="col-sm-4">
                            <a-form-item label="Distancia de refresco" required>
                                <a-input-number v-model="config.distanceDiff" class="w-100" :min="500" :max="100000" />
                            </a-form-item>
                        </div>
                        <div class="col-sm-4">
                            <a-form-item label="Desde" required>
                                <a-time-picker
                                    v-model="config.timeTrackFrom"
                                    format="HH:mm"
                                    placeholder=""
                                    class="w-100"
                                />
                            </a-form-item>
                        </div>
                        <div class="col-sm-4">
                            <a-form-item label="Hasta" required>
                                <a-time-picker
                                    v-model="config.timeTrackTo"
                                    format="HH:mm"
                                    placeholder=""
                                    class="w-100"
                                />
                            </a-form-item>
                        </div>
                    </div>
                </div>

                <div class="card-footer d-flex">
                    <a-button
                        class="ml-auto"
                        type="primary"
                        :loading="loading"
                        :disabled="!validated('tracking')"
                        @click="save('tracking')"
                    >
                        Guardar
                    </a-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Config',
    data() {
        return {
            config: {
                name: '',
                address: '',
                address2: '',
                CIF: '',
                mail: '',
                phone: '',
                logo: '',
                distanceDiff: 100000,
                timeTrackFrom: this.$moment('09:00', 'HH:mm'),
                timeTrackTo: this.$moment('20:00', 'HH:mm'),
                enableTaxes: true,
            },
            loading: false,
            uploading: false,
            imageUrl: '',
        }
    },
    async created() {
        const config = await this.$gestios.config.list(Object.keys(this.config))

        if (config.ok) {
            Object.keys(this.config).forEach((key) => {
                switch (key) {
                    case 'timeTrackFrom':
                    case 'timeTrackTo':
                        this.config[key] = this.$moment(config.data[key], 'HH:mm')

                        break
                    case 'enableTaxes':
                        this.config[key] = config.data[key] === '1' ? true : false
                        break
                    default:
                        this.config[key] = config.data[key]
                }
            })

            if (this.config.logo) this.imageUrl = this.config.logo
        }
    },
    methods: {
        async save(section) {
            if (this.validated(section)) {
                let params

                this.loading = true

                switch (section) {
                    case 'invoices':
                        params = {
                            name: this.config.name,
                            address: this.config.address,
                            address2: this.config.address2,
                            CIF: this.config.CIF,
                            mail: this.config.mail,
                            phone: this.config.phone,
                            enableTaxes: this.config.enableTaxes ? 1 : 0,
                        }
                        break

                    case 'tracking':
                        params = {
                            distanceDiff: this.config.distanceDiff,
                            timeTrackFrom: this.$moment(this.config.timeTrackFrom).format('HH:mm'),
                            timeTrackTo: this.$moment(this.config.timeTrackTo).format('HH:mm'),
                        }
                        break

                    default:
                        return
                }

                const result = await this.$gestios.config.edit(params)
                if (result.ok) this.$message.success('Configuracion guardada')

                this.loading = false
            }
        },
        validated(type) {
            if (type === 'invoices') {
                if (this.config.name && this.config.CIF && this.config.address) return true
                return false
            }
            if (type === 'tracking') {
                if (this.config.distanceDiff && this.config.timeTrackFrom && this.config.timeTrackTo) return true

                return false
            }

            return false
        },
        handleChange(info) {
            if (info.file.status === 'uploading') {
                this.uploading = true
                return
            }

            if (info.file.status === 'error' && info.file.error.status === 404) {
                this.getBase64(info.file.originFileObj, async (imageUrl) => {
                    const result = await this.$gestios.config.edit({ logo: imageUrl })
                    if (result.ok) this.$message.success('Configuracion guardada')

                    this.imageUrl = imageUrl
                    this.uploading = false
                })
            }
        },
        beforeUpload(file) {
            const isValid = file.type === 'image/jpeg' || file.type === 'image/png'
            if (!isValid) this.$message.error('You can only upload JPG file!')

            const isLt2M = file.size / 1024 / 1024 < 2
            if (!isLt2M) this.$message.error('La imagen debe pesar menos de 2MB')

            return isValid && isLt2M
        },
        getBase64(img, callback) {
            const reader = new FileReader()
            reader.addEventListener('load', () => callback(reader.result))
            reader.readAsDataURL(img)
        },
    },
}
</script>

<style lang="scss">
.logoUpload {
    .ant-upload.ant-upload-select-picture-card {
        width: 100%;
        height: 150px;
        margin-bottom: 0;

        img {
            max-width: 100%;
            max-height: 235px;
        }
    }
}
</style>
